export const availableLanguages = [
  'en',
  'es',
  'fr',
  'nl',
  'ru'
];
